// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file history_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyResponseSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file history_service.proto.
 */
export const file_history_service: GenFile = /*@__PURE__*/
  fileDesc("ChVoaXN0b3J5X3NlcnZpY2UucHJvdG8SC2dycGMuYXBpLnYxIicKDkhpc3RvcnlSZXF1ZXN0EhUKDXJlc2VydmF0aW9uSWQYASABKAUiHQoNSGlzdG9yeVJlY29yZBIMCgRqc29uGAEgASgJImwKD0hpc3RvcnlSZXNwb25zZRIrCgdyZWNvcmRzGAEgAygLMhouZ3JwYy5hcGkudjEuSGlzdG9yeVJlY29yZBIsCghtZXNzYWdlcxgCIAMoCzIaLmdycGMuYXBpLnYxLkhpc3RvcnlSZWNvcmQiMgoZUmVzZW5kQ29uZmlybWF0aW9uUmVxdWVzdBIVCg1yZXNlcnZhdGlvbklkGAEgASgFMrMBCg5IaXN0b3J5U2VydmljZRJHCgpnZXRIaXN0b3J5EhsuZ3JwYy5hcGkudjEuSGlzdG9yeVJlcXVlc3QaHC5ncnBjLmFwaS52MS5IaXN0b3J5UmVzcG9uc2USWAoScmVzZW5kQ29uZmlybWF0aW9uEiYuZ3JwYy5hcGkudjEuUmVzZW5kQ29uZmlybWF0aW9uUmVxdWVzdBoaLmdycGMuYXBpLnYxLkVtcHR5UmVzcG9uc2VCBloELjtwYmIGcHJvdG8z", [file_empty]);

/**
 * @generated from message grpc.api.v1.HistoryRequest
 */
export type HistoryRequest = Message<"grpc.api.v1.HistoryRequest"> & {
  /**
   * @generated from field: int32 reservationId = 1;
   */
  reservationId: number;
};

/**
 * Describes the message grpc.api.v1.HistoryRequest.
 * Use `create(HistoryRequestSchema)` to create a new message.
 */
export const HistoryRequestSchema: GenMessage<HistoryRequest> = /*@__PURE__*/
  messageDesc(file_history_service, 0);

/**
 * @generated from message grpc.api.v1.HistoryRecord
 */
export type HistoryRecord = Message<"grpc.api.v1.HistoryRecord"> & {
  /**
   * @generated from field: string json = 1;
   */
  json: string;
};

/**
 * Describes the message grpc.api.v1.HistoryRecord.
 * Use `create(HistoryRecordSchema)` to create a new message.
 */
export const HistoryRecordSchema: GenMessage<HistoryRecord> = /*@__PURE__*/
  messageDesc(file_history_service, 1);

/**
 * @generated from message grpc.api.v1.HistoryResponse
 */
export type HistoryResponse = Message<"grpc.api.v1.HistoryResponse"> & {
  /**
   * @generated from field: repeated grpc.api.v1.HistoryRecord records = 1;
   */
  records: HistoryRecord[];

  /**
   * @generated from field: repeated grpc.api.v1.HistoryRecord messages = 2;
   */
  messages: HistoryRecord[];
};

/**
 * Describes the message grpc.api.v1.HistoryResponse.
 * Use `create(HistoryResponseSchema)` to create a new message.
 */
export const HistoryResponseSchema: GenMessage<HistoryResponse> = /*@__PURE__*/
  messageDesc(file_history_service, 2);

/**
 * @generated from message grpc.api.v1.ResendConfirmationRequest
 */
export type ResendConfirmationRequest = Message<"grpc.api.v1.ResendConfirmationRequest"> & {
  /**
   * @generated from field: int32 reservationId = 1;
   */
  reservationId: number;
};

/**
 * Describes the message grpc.api.v1.ResendConfirmationRequest.
 * Use `create(ResendConfirmationRequestSchema)` to create a new message.
 */
export const ResendConfirmationRequestSchema: GenMessage<ResendConfirmationRequest> = /*@__PURE__*/
  messageDesc(file_history_service, 3);

/**
 * @generated from service grpc.api.v1.HistoryService
 */
export const HistoryService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.HistoryService.getHistory
   */
  getHistory: {
    methodKind: "unary";
    input: typeof HistoryRequestSchema;
    output: typeof HistoryResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.HistoryService.resendConfirmation
   */
  resendConfirmation: {
    methodKind: "unary";
    input: typeof ResendConfirmationRequestSchema;
    output: typeof EmptyResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_history_service, 0);

